import {addAuthToFetchOpts} from '../../config/queryopts'
import {useMutationWithAuthentication} from "../index";
import {apiUrlInternal} from "../../config/api"
import axios from "axios";
import {useQueryClient} from "react-query";


const _ = require('lodash');


export const AssignUserTakedownFetcher = (accessToken, params) => {
  return axios.put(
    `${apiUrlInternal}/takedown_tickets/assign/${params.uid}?user_uid=${params.user_uid}`, params, addAuthToFetchOpts(accessToken, {})
  ).then(res => res);
}

export const useAssignUserTakedownTicketMutation = (fetcher = AssignUserTakedownFetcher) => {
  const queryClient = useQueryClient()
  return useMutationWithAuthentication(
    ['update-user-takedown-ticket'],
    (accessToken, params) => fetcher(accessToken, params),
    {
      onSuccess: (_, params) => {
        queryClient.invalidateQueries('update-user-takedown-ticket')
        queryClient.invalidateQueries(['takedown-tickets', `/${params.uid}`])
        queryClient.invalidateQueries(['tickets', ''])
      }
    }
  )
}

